var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBuyCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.48 14.92v-.06c-.31-3.88-3.46-7.03-7.37-7.34h-.03A6.495 6.495 0 0 1 15.5 2 6.5 6.5 0 0 1 22 8.5c0 3.26-2.4 5.95-5.52 6.42z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02 9.02a6.5 6.5 0 1 0-1.04 12.96A6.5 6.5 0 0 0 9.02 9.02zM8.5 18l-.88-1.62L6 15.5l1.62-.88L8.5 13l.88 1.62 1.62.88-1.62.88L8.5 18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBuyCrypto);
export default __webpack_public_path__ + "static/media/vuesax-bold-buy-crypto.c86dd3840b8d731ca8680c8d2edc52db.svg";
export { ForwardRef as ReactComponent };